import {
  Badge,
  Box,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { Mail, MoreVertical } from "lucide-react";
import type { User } from "../../../../hooks/useUserManagement";
import type { UserRole } from "../../../../types";

interface UserListProps {
  users: User[];
  currentUserEmail?: string;
  sendingVerification: string | null;
  onRoleChange: (userId: string, newRole: UserRole) => void;
  onSendVerification: (userId: string) => void;
  onDelete: (userId: string) => void;
}

export function UserList({
  users,
  currentUserEmail,
  sendingVerification,
  onRoleChange,
  onSendVerification,
  onDelete,
}: UserListProps) {
  return (
    <Box overflowX="auto" bg="white" borderRadius="lg" boxShadow="sm">
      <Table variant="simple">
        <Thead bg="gray.50">
          <Tr>
            <Th>Nome</Th>
            <Th>Email</Th>
            <Th>Status Email</Th>
            <Th>Função</Th>
            <Th>Data de Criação</Th>
            <Th width="100px">Ações</Th>
          </Tr>
        </Thead>
        <Tbody>
          {users.map((user) => (
            <Tr key={user.id} _hover={{ bg: "gray.50" }}>
              <Td>{user.name || "N/A"}</Td>
              <Td>{user.email}</Td>
              <Td>
                <Badge
                  colorScheme={user.email_confirmed_at ? "green" : "yellow"}
                >
                  {user.email_confirmed_at ? "Verificado" : "Pendente"}
                </Badge>
              </Td>
              <Td>
                <Select
                  value={user.role}
                  onChange={(e) =>
                    onRoleChange(user.id, e.target.value as UserRole)
                  }
                  size="sm"
                  width="150px"
                  isDisabled={
                    user.email === currentUserEmail && user.role === "admin"
                  }
                >
                  <option value="admin">Administrador</option>
                  <option value="user">Usuário</option>
                </Select>
              </Td>
              <Td>
                {user.created_at
                  ? new Date(user.created_at).toLocaleDateString("pt-BR")
                  : "N/A"}
              </Td>
              <Td>
                <Menu>
                  <MenuButton
                    as={IconButton}
                    icon={<MoreVertical size={16} />}
                    variant="ghost"
                    size="sm"
                    aria-label="Ações do usuário"
                  />
                  <MenuList>
                    {!user.email_confirmed_at && (
                      <MenuItem
                        icon={<Mail size={14} />}
                        onClick={() => onSendVerification(user.id)}
                        isDisabled={sendingVerification === user.id}
                      >
                        {sendingVerification === user.id
                          ? "Enviando..."
                          : "Enviar Verificação"}
                      </MenuItem>
                    )}
                    <MenuItem
                      color="red.500"
                      onClick={() => onDelete(user.id)}
                      isDisabled={user.email === currentUserEmail}
                    >
                      Excluir
                    </MenuItem>
                  </MenuList>
                </Menu>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
}
